/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気契約値情報
 */
export interface Sgkb575aResElecConvalInfo {
    /** 
     * 契約電流：半角数字
     */
    conAmpA?: string;
    /** 
     * 契約電流名称：全角半角混在
     */
    conAmpAAname?: string;
    /** 
     * 契約容量：半角数値(小数点あり)
     */
    conCapKva?: number;
    /** 
     * 契約電力：半角数値(小数点あり)
     */
    conEleKw?: number;
    /** 
     * 受付時契約電流：半角数字
     */
    aceptjiConampa?: string;
    /** 
     * 受付時契約電流名称：全角半角混在
     */
    aceptjiConampaAname?: string;
    /** 
     * 受付時契約容量：半角数値(小数点あり)
     */
    aceptjiKeiyakuyoryo?: number;
    /** 
     * 受付時契約電力：半角数値(小数点あり)
     */
    aceptjiKeiyakudenryoku?: number;
    /** 
     * 供給電圧：半角数値(小数点なし)
     */
    supvlt?: number;
    /** 
     * 再エネ賦課金減免有無：半角英数混在
     */
    redtaxFlg?: string;
    /** 
     * 再エネ賦課金減免有無名称：全角半角混在
     */
    redtaxFlgAname?: string;
    /** 
     * 再エネ賦課金減免率：半角英数混在
     */
    redtaxPrcnt?: string;
    /** 
     * 再エネ賦課金減免率名称：全角半角混在
     */
    redtaxPrcntAname?: string;
    /** 
     * 再エネ賦課金減免開始日：日付YYYYMMDD
     */
    redStrtDate?: string;
    /** 
     * 再エネ賦課金減免終了日：日付YYYYMMDD
     */
    redEndDate?: string;
}
